<template>
  <b-col xs="12" sm="12" md="12" lg="12" xl="12">
    <iq-card>
      <template v-slot:body>
        <b-overlay :show="loadingState">
          <b-table-simple striped bordered small hover>
            <tbody>
              <b-tr v-if="tmpData.service_type_id"><b-th>Service Type</b-th> <b-td>{{ getServiceType(tmpData.service_type_id) }}</b-td></b-tr>
              <b-tr v-if="tmpData.service_name_id"><b-th>Service Name</b-th> <b-td>{{ getService(tmpData.service_name_id) }}</b-td></b-tr>
            </tbody>
            <b-tbody v-if="tmpData.eligibilities">
            <b-tr>
              <b-th colspan="2" class="text-center">
                  Service Eligibilities
              </b-th>
            </b-tr>
            <b-tr v-for="(item, index) in JSON.parse(tmpData.eligibilities)" :key="index">
                <b-td>
                    {{ $n(index + 1) }}
                </b-td>
                <b-td v-if="$i18n.locale === 'en'">
                    <ValidationProvider name="Title (En)" vid="eligibilities" rules="required">
                        <b-form-group
                            slot-scope="{ valid, errors }"
                            >
                            <b-form-input
                            v-model="item.eligibilities"
                            id="eligibilities"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            </b-form-input>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-td>
                <b-td v-if="$i18n.locale === 'bn'">
                    <ValidationProvider name="Title (Bn)" vid="instructor_id" rules="required">
                        <b-form-group
                            slot-scope="{ valid, errors }"
                            >
                            <b-form-input
                            v-model="item.eligibilities_bn"
                            id="eligibilities_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            </b-form-input>
                            <div class="invalid-feedback">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-td>
            </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-overlay>
      </template>
    </iq-card>
  </b-col>
</template>

<script>
import { socialWelfareServiceBaseUrl } from '@/config/api_config'
export default {
    props: ['id'],
    data () {
      return {
          url: socialWelfareServiceBaseUrl
      }
    },
    created () {
        this.tmpData = this.$store.state.list.find(item => item.id === this.id)
    },
    computed: {
      currentLocale: function () {
        return this.$i18n.locale
      }
    },
    methods: {
        getService (getServiceId) {
            const objectData = this.$store.state.SocialWelfareService.commonObj.serviceNameList.find(item => item.value === getServiceId)
            if (objectData) {
              if (this.$i18n.locale === 'bn') {
                  return objectData.text_bn
              } else {
                  return objectData.text_en
              }
            } else {
              return ''
            }
        },
        getServiceType (getServiceTypeId) {
            const objectData = this.$store.state.SocialWelfareService.commonObj.serviceTypeList.find(item => item.value === getServiceTypeId)
            if (objectData) {
              if (this.$i18n.locale === 'bn') {
                  return objectData.text_bn
              } else {
                  return objectData.text_en
              }
            } else {
              return ''
            }
        }
    }
}
</script>
